<template>
  <PageContainer>
    <SectionContainer class="pt-2">
      <h1>Recommendations</h1>
      <img src="https://withjoy.com/media/ea2d0ea6d5be9f535f403cfdb5e3515862d4085be61d8939e/c7189d50-ec2c-11ef-b02c-6f87c15e9a32-0d4530e9fbf1481b9f994fab9d74e6c4.jpg?rendition=medium" class="mt-16">
      <div>
        <h2>Getting In</h2>
        <p>For people flying in from overseas, we recommend flying into Manila, Ninoy Aquino International Airport.</p>
        <h2>Airport Transfer</h2>
        <ul>
          <li>Most hotels have airport transfers which you can arrange before your arrival.</li>
          <li>If you're flying from overseas, you can stay in Manila for few days depending on your arrival date in the Philippines.</li>
        </ul>
        <h2>Manila to Tagaytay</h2>
        <ul>
          <li>We recommend you find accommodation in Tagaytay as it is a couple hours away from Manila.</li>
          <li>There are various ways to get to Tagaytay, but we would recommend to hire a driver.</li>
          <li>Alternatively, you can try the "Grab" app which is similar to Uber. This might be a little expensive depending on traffic.</li>
        </ul>
        <h2>Recommended Hotels To Book in Tagaytay</h2>
        <ul>
          <li>Escala Tagaytay</li>
          <li>Taal Vista Hotel</li>
          <li>The Lake Hotel</li>
          <li>Summit Ridge Tagaytay</li>
          <li>Quest Hotel Tagaytay</li>
          <li>You can also try AirBnb!</li>
        </ul>
        <h2>Restaurants To Try in Tagaytay</h2>
        <ul>
          <li>Balay Dako by Antonio's</li>
          <li>Charito by Bag of Beans</li>
          <li>Leslie's Restaurant</li>
          <li>Breakfast at Antonio's</li>
          <li>Farmer's Table Tagaytay</li>
        </ul>
        <h2>I need help!</h2>
        <p>If you need help with anything, feel free to message us and we'll gladly assist! :)</p>
      </div>
    </SectionContainer>
  </PageContainer>
</template>

<script>
import PageContainer from '@/pages/PageContainer'
import SectionContainer from '@/pages/SectionContainer'

export default {
  name: 'RecommendationsPage',
  components: {
    PageContainer,
    SectionContainer,
  },
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
  },
}
</script>